import api from './api'

const MAIN_CATEGORY_BASE_URL = '/api/v1/fund-map/main-categories'
const SUB_CATEGORY_BASE_URL = '/api/v1/fund-map/sub-categories'

// INTERFACES
/*
main category
 {
   _id: string;
   title: string;
   icon: string;
   subCategories:{
    _id: string;
    title: string;
   }
 }


 sub category
  {
    _id: string;
    title: string;
  }
*/

// Main category api calls
export const getAllCategories = async () => {
  const response = await api.get(MAIN_CATEGORY_BASE_URL)
  return response.data
}

export const createMainCategory = async categoryData => {
  const response = await api.post(MAIN_CATEGORY_BASE_URL, categoryData)
  return response.data
}

export const patchMainCategory = async (id, partialCategoryData) => {
  const response = await api.patch(`${MAIN_CATEGORY_BASE_URL}/${id}`, partialCategoryData)
  return response.data
}

export const deleteMainCategory = async id => {
  const response = await api.delete(`${MAIN_CATEGORY_BASE_URL}/${id}`)
  return response.status
}

// Sub category api call
export const getAllSubCategories = async () => {
  const response = await api.get(SUB_CATEGORY_BASE_URL)
  return response.data
}

export const getSubCategoryById = async subCategoryId => {
  const response = await api.get(`${SUB_CATEGORY_BASE_URL}/${subCategoryId}`)
  return response.data
}

export const createSubCategory = async categoryData => {
  const response = await api.post(SUB_CATEGORY_BASE_URL, categoryData)
  return response.data
}

export const patchSubCategory = async (id, partialCategoryData) => {
  const response = await api.patch(`${SUB_CATEGORY_BASE_URL}/${id}`, partialCategoryData)
  return response.data
}

export const deleteSubCategory = async id => {
  const response = await api.delete(`${SUB_CATEGORY_BASE_URL}/${id}`)
  return response.status
}
